import React from 'react'

import { Box, Typography } from '@material-ui/core'

import useStyles from './styles'

const PortalLoadingScreen = ({
  message = 'Validando link e carregando as configurações do portal',
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Box className={classes.ambientGlow} />
      <Box className={classes.stack}>
        <Box className={classes.spinnerWrap}>
          <svg
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            className={classes.spinner}
            aria-hidden="true"
          >
            <circle cx="50" cy="50" r="40" className={classes.guide} />
            <g className={classes.arcGroup}>
              <circle cx="50" cy="50" r="40" className={classes.arc} />
            </g>
            <g className={classes.dotGroup}>
              <circle cx="50" cy="50" r="2.6" className={classes.dot} />
            </g>
          </svg>
        </Box>

        <Box className={classes.rule} />

        <Typography component="span" className={classes.label}>
          PREPARANDO ACESSO
        </Typography>

        <Typography component="p" className={classes.message}>
          {message}
        </Typography>
      </Box>
    </Box>
  )
}

export default PortalLoadingScreen
